import { useEffect, useState } from 'react';

import { FirstDataRenderedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultFreshShipmentColDef } from '@/grid/defaults';
import { TOA_GetFreshShipmentFertList } from '@/rtk-query.gql';

import { signedOffGridColDefs } from '../utils/columnDefs';
import { gridOptions, rowClassRules } from '../utils/constants';

type FreshShipmentSignedOffGridProps = {
  className: string;
  themeMode: string;
  fertilizations: TOA_GetFreshShipmentFertList[] | undefined;
  me: string;
  quickSearchValue: string;
  onFirstDataRendered: (params: FirstDataRenderedEvent) => void;
  gridRef: React.RefObject<AgGridReact>;
};

export const FreshShipmentSignedOffGrid = ({
  gridRef,
  className,
  themeMode,
  fertilizations,
  me,
  quickSearchValue,
  onFirstDataRendered,
}: FreshShipmentSignedOffGridProps) => {
  const defaultGridOptions = useDefaultGridOptions();
  const [donorNameDuplicates, setDonorNameDuplicates] = useState(new Set());

  useEffect(() => {
    const newDonorNameDuplicates = new Set();
    const donorNameSet = new Set();

    fertilizations?.forEach((row) => {
      if (donorNameSet.has(row.donorName)) {
        newDonorNameDuplicates.add(row.donorName);
      } else {
        donorNameSet.add(row.donorName);
      }
    });

    setDonorNameDuplicates(newDonorNameDuplicates);
  }, [fertilizations]);

  return (
    <div className="fresh-shipment-form__grid">
      <WithLocalStorage storageKey={`fresh-shipments-grid`}>
        <AgGridReact
          className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}${className ? ` ${className}` : ''} with-vertical-lines`}
          rowData={fertilizations}
          getRowId={(params) => params.data.fertilizationId}
          defaultColDef={defaultFreshShipmentColDef}
          rowClassRules={rowClassRules}
          columnDefs={signedOffGridColDefs}
          overlayLoadingTemplate="Please Select a Site and a Date"
          rowSelection="multiple"
          quickFilterText={quickSearchValue}
          context={{ me, donorNameDuplicates }}
          gridOptions={{ ...defaultGridOptions, ...gridOptions }}
          ref={gridRef}
          suppressRowClickSelection={true}
          suppressRowHoverHighlight={true}
          onFirstDataRendered={onFirstDataRendered}
        />
      </WithLocalStorage>
    </div>
  );
};
